import useLocalStorage from 'use-local-storage'

export const useNavbarStorage = () => {
  const [expandedStorage, setExpandedStorage] = useLocalStorage<boolean>(
    '@barfacil-adm/navbar-expanded',
    true,
    {
      syncData: false,
    },
  )

  return { expandedStorage, setExpandedStorage }
}
